<template>
  <div class="home">
    <keep-alive>
      <router-view />
    </keep-alive>
    <!-- <el-button size="small" type="primary" @click="openDia">打开弹窗</el-button>
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose">
      123
      {{$myStore.state.user.userInfo.companyName}}
      <el-button type="primary" size="small" @click="tips">提示</el-button>
      <el-button type="primary" size="small" @click="$myRouter.push({path: '/home'})">跳转</el-button>
    </el-dialog> -->

  </div>
</template>

<script>

// import { getJobs } from '@/api/api'
export default {
  name: 'Home',
  data () {
    return {
      // dialogVisible: false
    }
  },
  methods: {
    // async getJobs () {
    //   const res = await getJobs({ page: 1, limit: 10 })
    //   console.log(res.data)
    // },
    // openDia () {
    //   this.getJobs()
    //   this.dialogVisible = true
    // },
    // handleClose () {
    //   this.dialogVisible = false
    // },
    // tips () {
    //   this.$message.success('12345678')
    // }
  }
}
</script>
